const entityFields = {
    NotFound: [
        { name: "title", type: "text", label: "Titlu", tag: "h1", region: "header" },
        { name: "body", type: "html", label: "Conținut" },
    ],
    homepage: [],
    page: [
        //{ name: "header", type: "img", label: "Antet", region: "other" },
        { name: "title", type: "text", label: "Titlu", tag: "h1", region: "header" },
        { name: "body", type: "html", label: "Conținut" },
    ],
    bg: [
        { name: "bg", type: "img", label: "Fundal", region: "bg" },
        { name: "interval", type: "int", label: "Interval", region: "none" },
    ],
    menu: [
        { name: "label", type: "text", label: "Nume" },
        { name: "items", type: "list", items: "menuItem", label: "Meniuri" },
    ],
    footer: [],
}
export { entityFields }
